import React, { useEffect, useState } from 'react';
import PropTypes from "prop-types";
import StandardTooltip from "../StandardTooltip";
import RestoreIcon from "@mui/icons-material/Restore";
import UpdateIcon from '@mui/icons-material/Update';
import AddIcon from '@mui/icons-material/Add';
import CircularProgress from '@mui/material/CircularProgress';

const AvailabilityButtonConsecutive = (props) => {

    return (
        <StandardTooltip title={props.tooltipMessage}>
            <div style={{display: 'inline-block'}}>
                <button
                    type="button"
                    className={`button round availability-button consecutive ${props.active ? 'primary': 'secondary'} ${props.className}`}
                    onClick={props.onClick}
                    disabled={props.canExtend !== true}
                    style={{textTransform: 'initial'}}
                >
                    <span>
                        {(props.type === 'earlier') && <>
                            <AddIcon/>

                            {(props.canExtend !== null)
                                ? <RestoreIcon/>
                                : <span style={{position: 'relative', top: '-0.25rem', left: '0.25rem'}}>
                                     <CircularProgress size="1rem"/>
                                 </span>
                            }
                        </>}

                        {(props.type === 'later') && <>
                            {(props.canExtend !== null)
                                ? <UpdateIcon/>
                                : <span style={{position: 'relative', top: '-0.25rem', left: '-0.25rem'}}>
                                    <CircularProgress size="1rem"/>
                                </span>
                            }
                            <AddIcon/>
                        </>}
                    </span>
                </button>
            </div>
        </StandardTooltip>
    );
}

AvailabilityButtonConsecutive.propTypes = {
    type: PropTypes.oneOf(['earlier', 'later']),
    onClick: PropTypes.func,
    className: PropTypes.string,
    canExtend: PropTypes.oneOf([true, false, null])
}

AvailabilityButtonConsecutive.defaultProps = {
    tooltipMessage: '',
}

export default AvailabilityButtonConsecutive;
